import { Navigate, Outlet } from 'react-router-dom'
import { useContext } from 'react'
import { AuthContext } from '../utils/auth-provider'

const PrivateRoute = () => {
  const { currentUser, pending } = useContext(AuthContext);
  
  return (
    !!pending || !!currentUser ? <Outlet/> : <Navigate to='/login'/> 
  )
}

export default PrivateRoute;